jQuery(function($) {
    // Detect if there is a product list
    let productList = document.querySelector('#marina_posts_wrap');
    let cat = '';

    const params = new window.URLSearchParams(window.location.search);
    if(params) {
        cat = params.get('treatment');
    }

    if(productList) {
        // Search initialization
        let page = 0;
        let busy = false;
        let filter = {
            problem: [],
            productType: [],
            traitement: []
        };
        const $loading = $('#loading');

        // Function called when a search is triggered by the user
        const triggerProductsSearch = (pageIndex = 1) => {
            // Bail early if a search is already happening
            if(busy) return;

            busy = true;

            // Empty products list before search
            productList.innerHTML = "";
            
            page = pageIndex;

            // Get search filters values
            filter.problem = getFilterValue('problem');
            filter.traitement = getFilterValue('traitement');
            filter.productType = getFilterValue('product-type');  
            
            // Get treatment category from `treatment` GET parameter        
            // Trigger AJAX products search request
            const request = $.ajax({
                url: ajaxurl.ajaxurl,
                method: 'POST',
                data: {
                    action: "get_product",
                    params: {
                        page,
                        filter,
                        cat
                    }
                },
                beforeSend: showLoadingIndicator
            });
            request.done(onProductsSearchDone);
            request.always(hideLoadingIndicator);


        };

        // Function called when the search ajax request is done
        const onProductsSearchDone = (data) => {
            if(data.success) {
                // On ajoute les posts en plus
                productList.innerHTML = data.data.html;


                $('.pagination-item > a').on('click', function(e) {
                    e.preventDefault();
                    window.scrollTo({top: 0,behavior: 'smooth'});

                    triggerProductsSearch(e.target.getAttribute('data-page'));

                });
                $('.page-products__filters').on('change', 'input:checkbox', function() {
                    triggerProductsSearch();
                });

               
                busy = false;
            } else {
                productList.innerHTML = "Pas de correspondance..";

            }

            // On previent qu'on a fini le chargement
            busy = false;
        };

        // Function called before search
        const showLoadingIndicator = () => {
            $('.page-products__filters input:checkbox').attr('disabled', true);
            $('.page-products__filters').addClass('busy');
            $loading.show();
        };

        // Function called after search
        const hideLoadingIndicator = () => {
            $('.page-products__filters input:checkbox').removeAttr('disabled');
            $('.page-products__filters').removeClass('busy');
            $loading.hide();
        };

        /**
         * Get a search filter value by its name
         */
        const getFilterValue = function(filterName) {
            let values = [];
            $('input.' + filterName + '-checked').each(function(index, checkbox)  {
                if(($(checkbox).is(':checked')) ) {
                    values.push($(this).val());
                }
            });
            cat=""

            return values;
        };

        // Trigger products search on DOM ready
        $(document).ready(function() {
            triggerProductsSearch();
        });
        
    }
});
